"use client";

import React, {useEffect, useState} from "react";
import dynamic from "next/dynamic";
import type { NavbarProps } from "./interface";

import styles from "./Navbar.module.scss";
import { CloseOutlined, MenuOutlined } from "@/app/[lang]/components/ui/AntdLite";

// The antd Drawer (rc-drawer + rc-motion + portal) loads on first menu open
// instead of shipping in the initial bundle of every page.
const NavbarMobileDrawer = dynamic(() => import("./NavbarMobileDrawer"), {
    ssr: false,
    loading: () => null,
});

type ActiveMenu =
    | {
    title: string;
    items: any[];
    columns?: never;
}
    | {
    title: string;
    columns: any[];
    items?: never;
}
    | null;

type NavbarMobileProps = {
    navigationButton: NavbarProps["navigationButton"];
    isDrawerOpen: boolean;
    setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    menuStack: ActiveMenu[];
    setMenuStack: React.Dispatch<React.SetStateAction<ActiveMenu[]>>;
    activeMenu: ActiveMenu;
};

  export const NavbarMobile:React.FC<NavbarMobileProps> = (props) => {
      const {
          isDrawerOpen,
          setIsDrawerOpen,
          navigationButton,
          setMenuStack,
          activeMenu,
      } = props;

      // Once opened, keep the drawer mounted so the close animation still runs.
      const [everOpened, setEverOpened] = useState(false);

      useEffect(() => {
          if (isDrawerOpen) {
              setEverOpened(true);
          }
      }, [isDrawerOpen]);

      return (
      <div className={ styles.mobileWrapper }>
          <NavbarMobileToggle
              isToggled={isDrawerOpen}
              toggle={setIsDrawerOpen}
              setMenuStack={setMenuStack}
          />

          {(isDrawerOpen || everOpened) && (
              <NavbarMobileDrawer
                  navigationButton={navigationButton}
                  isDrawerOpen={isDrawerOpen}
                  setIsDrawerOpen={setIsDrawerOpen}
                  setMenuStack={setMenuStack}
                  activeMenu={activeMenu}
              />
          )}
      </div>
    )
  }

type NavbarMobileToggleProps = {
    isToggled: boolean;
    toggle: (value: boolean) => void;
    setMenuStack: React.Dispatch<React.SetStateAction<ActiveMenu[]>>;
};

const NavbarMobileToggle: React.FC<NavbarMobileToggleProps> = ({
                                                                   toggle,
                                                                   isToggled,
                                                                   setMenuStack,
                                                               }) => {
    if (isToggled) {
        return (
            <CloseOutlined
                onClick={() => {
                    toggle(false);
                    setMenuStack([]);
                }}
                className={styles.icon}
            />
        );
    }

    return (
        <MenuOutlined
            onClick={() => toggle(true)}
            className={styles.icon}
        />
    );
};
